import { Component, Input, OnInit } from '@angular/core';
import { UtilitiesService } from '@services/utilities.service';
import { BehaviorSubject } from 'rxjs';
import { IHeaderDistributorDetail } from '../../../interfaces/detail-header.interface';
import { ITabList } from '@shared/interface/tablist.interface';
import { TabListLabelDetailDistributor } from '../../../enum/tablist-label.enum';
import { DistributorService } from '../../../distributor.service';

@Component({
  selector: 'app-detail-verification',
  templateUrl: './detail-verification.component.html',
  styleUrls: ['./detail-verification.component.scss'],
})
export class DetailVerificationComponent implements OnInit {
  @Input() detailHeaderSubject!: BehaviorSubject<IHeaderDistributorDetail>;

  tabIndex = 0;
  tabList!: ITabList[];

  constructor(public utilities: UtilitiesService, private distributorService: DistributorService) {}

  ngOnInit() {
    this.detailHeaderSubject.subscribe((res) => {
      if (!res) return;
      this.initTabList();
    });
  }

  initTabList() {
    const { status_enum } = this.detailHeaderSubject.value;
    this.tabList = this.distributorService.generateDistributorDetailTabList(status_enum);
    this.tabList.map((tab, index) => {
      tab.privilege = true;
      tab.index = index;
      tab.component = this.distributorService.setTabListComponent(tab.enum, status_enum);
    });
  }

  handleTabChange = (e: number) => (this.tabIndex = e);

  isDetailHeaderLoaded() {
    return this.detailHeaderSubject && Object.keys(this.detailHeaderSubject.value).length > 0;
  }

  protected readonly TabListLabelDetailDistributor = TabListLabelDetailDistributor;
}
